import * as React from 'react';
import { connect } from 'react-redux';
import { Col, Row, Button } from 'reactstrap';
import { momentToString, timestampToMoment } from 'src/share/utils/utils';
import ConfirmationModal from 'src/share/components/ConfirmationModal/ConfirmationModal';
import { IReduxState } from 'src/reduxTypes';
import { UserTypes, IAuthState } from 'src/modules/Auth/store/types';

export interface IMatchCardProps {
  auth: IAuthState;
  history: any;
  matchData: any;
  deleteMatch: (matchId) => () => void;
  deleting: boolean;
};

export interface IMatchCardState {
  showDelete: boolean;
}

export class MatchBiometricaCard extends React.Component<IMatchCardProps, IMatchCardState> {
  constructor(props: IMatchCardProps) {
    super(props);
    this.state = {
      showDelete: false
    }
  }
  public modalToggle = () => {
    this.setState({ showDelete: !this.state.showDelete })
  }
  public isAdmin() {
    return this.props.auth.userType === UserTypes.ADMIN;
  }
  public render() {
    const { date, matchId, photoFace, provider, similarity, suspects, requester } = this.props.matchData;
    return (
      <Col xl="4" lg="6" md="12" sm="12" xs="12">
        <div className="info-card white-background">
          <Row>
            <Col md="3" sm="3" xs="3" className="images-column">
              <div className="image-biometrica-background">
                <img src={photoFace.url} alt="Face" />
              </div>
            </Col>
            <Col md="9" sm="9" xs="9">
              <Row>
                <div className="match-data">
                  <div className="date">
                    <p><label>Match date:</label><span className="subFont">{date ? momentToString(timestampToMoment(date)) : 'Unknown'}</span></p>
                  </div>
                  <p><label>Provider:</label><span className="subFont">{provider || 'Unknown'}</span></p>
                  <p><label>Faces detected results:</label><span className="subFont">{suspects || 'Unknown'}</span></p>
                  <p><label>Highest similarity:</label><span className="subFont">{similarity ? Math.round(similarity) : '-'}/100</span></p>
                  {requester && <p><label>Requester:</label><span className="subFont">{requester}</span></p>}
                </div>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col className="text-right" md="12" sm="12" xs="12">
              {this.isAdmin() && <Button className="btn-blue" onClick={() => this.modalToggle()}>
                Discard
                </Button>}
              <Button className="btn-blue" onClick={() => this.props.history.push(`/rekognition/matches/biometrica/${matchId}`)}>
                View
              </Button>
            </Col>
          </Row>
        </div>
        <ConfirmationModal
          isOpen={this.state.showDelete}
          toggle={() => {
            this.modalToggle();
          }}
          title={'Discard Match'}
          description={this.props.deleting ? 'Discarding match...' : 'Are you sure you want to discard this match'}
          onContinue={this.props.deleteMatch(matchId)}
          loading={this.props.deleting}
          showButtons={!this.props.deleting}
        />
      </Col>
    );
  }
}
const mapStateToProps = (state: IReduxState) => ({
  auth: state.auth
});
export default connect(mapStateToProps)(MatchBiometricaCard);